/* eslint-disable no-underscore-dangle */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Grid, Typography } from '@material-ui/core';
import learningLinksActions from '../../../redux/actions/learningLinksActions';
import ThemesLoader from '../../Loader/ThemesLoader';
import TextCard from './TextCard';
import ThemeCard from './ThemeCard';
import ModuleCard from '../../Elearning/components/content/ModuleCard';

const DisplayThemes = ({ learningLinks, getAllThemes }) => {
  useEffect(() => {
    getAllThemes();
  }, []);

  return (
    <div>
      <TextCard />
      <Typography
        component="h2"
        variant="h5"
        aria-label="Liste des thèmes"
        style={{
          marginBottom: '20px',
          backgroundColor: '#3E5EA7',
          color: '#fff',
          padding: '10px',
          borderRadius: '5px',
        }}
      >
        Themes
      </Typography>
      <Grid container component="section" aria-label="Thèmes disponibles" style={{ marginLeft: '7px' }}>
        {
          learningLinks.requestingThemes ? (
            <ThemesLoader />
          ) : (
            learningLinks.themes.map((theme) => (
              <ThemeCard
                key={theme._id}
                id={theme._id}
                name={theme.name}
                img={theme.img}
              />
            ))
          )
        }
      </Grid>
      <Typography
        variant="h5"
        component="h5"
        style={{
          marginBottom: '20px',
          backgroundColor: '#3E5EA7',
          color: '#fff',
          padding: '10px',
          borderRadius: '5px',
        }}
      >
        Module
      </Typography>
      <Grid container style={{ marginLeft: '7px', marginBottom: '30px' }}>
        <ModuleCard
          id="68775671a6c9eb000b90132a"
          title="International mobility"
          isRise
          objectives={{}}
          thumbnail="thmb_social_workers.svg"
          key="68775671a6c9eb000b90132a"
        />
      </Grid>

    </div>
  );
};

DisplayThemes.propTypes = {
  learningLinks: PropTypes.object.isRequired,
  getAllThemes: PropTypes.func.isRequired,
};

function mapState(state) {
  const { learningLinks } = state;
  return { learningLinks };
}

const actionCreators = {
  getAllThemes: learningLinksActions.getAllThemes,
};

const connectedDisplayThemes = connect(mapState, actionCreators)(DisplayThemes);
export default connectedDisplayThemes;
